import {RuntimeMode} from "../js/utils/Types.ts";

//region API URL
export const ROOMJACK_API_URL = "https://roomjack.at:5972/";
//endregion
//region Stripe public key
export const STRIPE_PUBLIC_KEY = 'pk_live_51M1mEbDXxFAIpgi2T71xzvU9kEJzX6DQ3nnaVf9H93wu1T4s42UBKm0Ry9L6cNOUrKnwjmwAEByf6dWn2osZhExk00kXOKOTko';
//endregion
export const RUNTIME_MODE = RuntimeMode.production;
